import { useContext } from "react";

import { PusherContextV2 } from "@lib/pusher";
import type { PusherContextV2Value } from "@lib/pusher";

export const usePusherContextV2 = (): PusherContextV2Value => {
  const context = useContext(PusherContextV2);
  if (context === undefined) {
    throw new Error("usePusherContextV2 must be used within a PusherProviderV2");
  }
  return context;
};
